import styled from "vue-styled-components";

export const CProductSingleTabs = styled.div``

export const CNavTabs = styled.div`
    ul {
        border-bottom: 1px solid ${props => props.theme?.products?.product_page?.tab_content?.border_color ?? '#dee2e6'} !important;
        > li {
            > a {
                font-family: ${props => props.theme?.footer?.font_family_title ?? props.theme?.font_family}, sans-serif !important;
                &.color-nav-link {
                    color: ${props => props.theme?.products?.product_page?.tab_content?.color ?? '#282d3b'} !important;
                }
                &:hover {
                    color: ${props => props.theme?.products?.product_page?.tab_content?.color_active ?? props.theme.primary_color} !important;
                }
            }

            .active.color-nav-link {
                background-color: transparent !important;
                color: ${props => props.theme?.products?.product_page?.tab_content?.color_active ?? props.theme.primary_color} !important;
                border-bottom-color: ${props => props.theme?.products?.product_page?.tab_content?.border_color_active ?? props.theme.primary_color} !important;
            }
        }
    }
`

export const CTabContent = styled.div`
    #no-description-product,
    .product-desc-content {
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
    }
    .entry-body {
        border-bottom: 1px solid #ddd;
    }
`